/**
 * The deployment-level options that sit next to `ProceduresList` in an export
 * request. They are edited in the modal's "Export settings" section and sent
 * PascalCased (see Integrations/services/exportProcedures.ts).
 */
export type IntegrationExportSettings = {
    split: string;
    createWbtCourse: boolean;
    playerTemplate: string;
    contentFolder: string;
    contentProvider: string;
    contentServer: string;
    owner: string;
};

/**
 * Prefilled values, taken from the reference request. `split` is a free-text
 * input for now — turn it into a select once the accepted values are known.
 */
export const DEFAULT_EXPORT_SETTINGS: IntegrationExportSettings = {
    split: 'External',
    createWbtCourse: true,
    playerTemplate: 'Standard Content Player Template',
    contentFolder: 'WEAVR-Test',
    contentProvider: 'WEAVR',
    contentServer: 'Default Saba Content Server',
    owner: 'uone',
};
